import { render, staticRenderFns } from "./ContractReview.vue?vue&type=template&id=30b2aefa&scoped=true&"
import script from "./ContractReview.vue?vue&type=script&lang=ts&"
export * from "./ContractReview.vue?vue&type=script&lang=ts&"
import style0 from "./ContractReview.vue?vue&type=style&index=0&id=30b2aefa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2aefa",
  null
  
)

export default component.exports